import { render } from "./Software.vue?vue&type=template&id=8a11f9e6"
import script from "./Software.vue?vue&type=script&lang=js"
export * from "./Software.vue?vue&type=script&lang=js"

import "./Software.vue?vue&type=style&index=0&id=8a11f9e6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__